var page = page || {};

page.team = (function ($) {
    calcPhotoLeft = function(photo) {

        var photo = photo ? photo : $('.team--active').find('.team__photo-wrap');

        // calculate a new left based on wrapper mid point - half photo width
        var wrapper = $(".our-team__wrapper").offset();
        var wrapperMid = $(".our-team__wrapper").outerWidth() *0.5;
        var photoMid = photo.outerWidth() * 0.5;

        return wrapper.left + wrapperMid - photoMid;

    },
    calcPhotoTop = function(title) {
        var title = title ? title : $('.team__popup--active').find('.team__title');

        // calculate a new top based on title position + title height

        var titleHeight = title.outerHeight(true);
        var titlePos = title.offset(); 

        return titlePos.top + titleHeight;
    },
    calcBioMargin = function(photo) {
        var photo = photo ? photo : $('.team--active').find('.team__photo-wrap');

        //calculate a margin for bio to push it below the photo
        return photo.outerHeight(true);

    },
    setPageHeight = function() {
        var popupHeight = $(".team__popup--active .team__popup-inner").outerHeight(true);
        $(".our-team__wrapper").css({'height': popupHeight, 'overflow': 'hidden' });
    },
    releasePageHeight = function() {
      $(".our-team__wrapper").removeAttr('style');  
    },

    scrollToProfileTop = function(){
        var element = $('.outer--pad-2-3');
        
        // Check element exists before proceeding with the scroll.
        if(element.length > 0){

            // Set the offset locally so we can manipulate it.
            var offset = element.offset().top;

            // The header gets in the way so check it exists, if it does minus off the header height so the top of the pop falls belwo the header on scroll.
            if($('header').length > 0) offset = (offset - $('header').outerHeight());

            // Fire!
            $('html, body').animate({
                scrollTop: (offset)
            }, 'fast');
        }
    },

	showProfile = function(team, group, popup) {

        var photo = team.find('.team__photo-wrap');
        var bio = $(popup).find('.team__bio');
        var title = $(popup).find('.team__title');

        var nextLink = $(popup).find('.team__nav--next');
        var nextTeamId = team.next('.team').data('team-id');

        var prevLink = $(popup).find('.team__nav--prev');
        var prevTeamId = team.prev('.team').data('team-id');
        
        // find the current picture offset on the page and set it
        var photoPos = photo.offset();
        photo.offset({ top: photoPos.top, left: photoPos.left });

        $(popup).addClass("team__popup--active");

        newLeft = calcPhotoLeft(photo);

        newTop = calcPhotoTop(title);

        photoHeight = calcBioMargin(photo);

        team.addClass("team--active");

        bio.css({'marginTop' : photoHeight });

        photo.offset({ top: newTop, left: newLeft });

        setPageHeight();

        // Trigger a 'scroll up' so that all of the pop up content is visible.
        scrollToProfileTop();

		
        // disable the next link if it's not in this tab
        if(nextTeamId == undefined) {
            nextLink.addClass('team__nav--hidden');
        }

        // disable the prev link if it's not in this tab
        if(prevTeamId == undefined) {
            prevLink.addClass('team__nav--hidden');
        }        
	},
    hideProfile = function() {
        $('.team__popup--active').removeClass('team__popup--active');
        //$('.team--active .team__photo-wrap').removeAttr('style');
        $('.team--active .team__photo-wrap').css({'top': 0, 'left': 0});
        $('.team--active').removeClass('team--active');
        releasePageHeight();
    },
    teamLink = function() {
        $(".team__link").click(function(e) {
            e.preventDefault();
            var team = $(this).parent('.team');
            var group = $(this).parent('.team__group');
            var popup = $(this).attr('href');
            showProfile(team, group, popup);

        });
    },
    teamBack = function() {
        $(".team__back").click(function(e) {
            hideProfile();
            e.preventDefault();
        });
    },
    teamNav = function() {
        $(".team__nav").click(function(e) {
            hideProfile();
            e.preventDefault();
            var teamId = $(this).data('team-id');
            var team = $("#team--" + teamId);
            var group = team.parent('.team__group');
            var popup = $(this).attr('href');
            showProfile(team, group, popup);
        });
    }
    profileResize = function() {
        $(window).on("debouncedresize", function( event ) {
            if($(".team__popup--active").length) {

                var title = $(".team__popup--active").find('.team__title');
                var bio = $(".team__popup--active").find('.team__bio');
                var photo = $('.team--active').find('.team__photo-wrap');

                newLeft = calcPhotoLeft(photo);
                newTop = calcPhotoTop(title);
                photoHeight = calcBioMargin(photo);

                bio.css({'marginTop' : photoHeight });

                photo.offset({ top: newTop, left: newLeft });

                setPageHeight();                

            }
        });
    },
    init = function () {
    	teamLink();
        teamBack();
        teamNav();
        profileResize();
    };

    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(page.team.init);